import { DOMParser, XMLSerializer } from 'xmldom';

const xmlDomUtils = {
    getChildNodes(xmlElement, tagName) {
        return Array.from(
            xmlElement.getElementsByTagName(tagName)
        );
    },

    getChildElements(xmlElement) {
        return Array
            .from(xmlElement.childNodes)
            .filter(node => node.nodeType === 1);
    },

    getAttributes(xmlElement) {
        return Array
            .from(xmlElement.attributes)
            .reduce((accumulator, attribute) => {
                accumulator[attribute.nodeName] = attribute.textContent;
                return accumulator;
            }, {});
    },

    hasClass(xmlElement, className) {
        return this.getClassList(xmlElement).includes(className);
    },

    hasClasses(xmlElement, classNames) {
        return classNames.every(className => this.hasClass(xmlElement, className));
    },

    removeClass(xmlElement, className) {
        const classesString = this
            .getClassList(xmlElement)
            .filter(cName => cName !== className)
            .join(' ');
        xmlElement.setAttribute('class', classesString);
    },

    getXmlDocFromString(xmlString) {
        return new DOMParser().parseFromString(xmlString, 'text/xml');
    },

    getElementFromString(xmlString) {
        if (!xmlString) {
            return null;
        }
        const xmlDoc = this.getXmlDocFromString(this.wrapHtmlStringIfNeeded(xmlString));
        return xmlDoc?.firstChild;
    },

    isDomParsableString(xmlString) {
        if (!xmlString || typeof xmlString !== 'string') {
            return false;
        }
        const reg = /<\/|\/>|<br|<img /gi;
        return reg.test(xmlString);
    },

    wrapHtmlStringIfNeeded(htmlString, wrapperTag = 'span') {
        const trimmedHtmlString = htmlString ? htmlString.trim() : '';
        if (!trimmedHtmlString.startsWith('<') && trimmedHtmlString.includes('<')) {
            return `<${wrapperTag}>${htmlString}</${wrapperTag}>`;
        }
        return htmlString;
    },

    getClassList(xmlElement) {
        const attributes = this.getAttributes(xmlElement);
        const classAttribute = attributes.class || '';
        return classAttribute.split(/\s+/).filter(className => className.length > 0);
    },

    stringify(xmlElement) {
        return new XMLSerializer().serializeToString(xmlElement);
    },
};

export default xmlDomUtils;
